module.exports = __webpack_public_path__ + "static/media/portfolio12.952f9a72.webp";